// //*for live api use with code uncomment============>>>>/*
export const environment = {
  production: false,
  apiUrl:'https://partnerapi.fareboutique.com/v1/',
  url:'https://partnerapi.fareboutique.com/',
  imageurl:'https://api.fareboutique.com/uploads/airlines/',
  XAPI_KEY:'15ASGF1656932294108'
};

// //*for devapi use uncomment============>>>>*/
// export const environment = {
//   production: false,
//   apiUrl:'https://devpatnerapi.fareboutique.com/v1/',
//   url:'https://devpatnerapi.fareboutique.com/',
//   imageurl:'https://devapi.fareboutique.com/uploads/airlines/',
//   XAPI_KEY:'1FMQKB1639407126571'
// };

